<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Quicksand", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html {
  overflow: auto;
}
.q-danger-bk {
  color: red !important;
}
.q-danger {
  background: red !important;
}
.q-orange {
  color: #d5725b !important;
}
.q-orange-bk {
  background-color: #d5725b !important;
}
.q-disabled {
  color: #ec7963 !important;
}
.q-disabled-bk {
  background-color: #ec7963 !important;
}
.q-whitesmoke-bk {
  background-color: var(--background-full) !important;
}
.q-text-whitesmoke {
  color: whitesmoke !important;
}
.q-green-add-bk {
  background-color: #7ab317 !important;
}
.q-orange-disable-bk {
  background-color: #cc8a47 !important;
}
.q-green-add-color {
  color: #7ab317 !important;
}
.q-orange-disable-color {
  color: #cc8a47 !important;
}
.hover {
  transition: background-color 0.2s linear;
  -moz-transition: background-color 0.2s linear;
  -webkit-transition: background-color 0.2s linear;
  -o-transition: background-color 0.2s linear;
  -ms-transition: background-color 0.2s linear;
}
.hover:hover {
  background-color: #e6d6b8 !important;
}
.q-headline {
  font-size: 32px !important;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
  margin-bottom: 10px;
}
.myh1 {
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}
.myh2 {
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}
.v-footer a {
  color: whitesmoke !important;
  text-decoration: none;
}
.dash-card {
  margin: 10px;
}
.d-none {
  display: none;
}
.no-padding {
  padding: 0 !important;
}
.text-center {
  text-align: center !important;
  width: 100%;
}
.centered-input input {
  text-align: center;
}
.center {
  text-align: center;
}
:root {
  --background-color: whitesmoke;
  --background-full: white;
  --text-color: #333;
  --even-bk: #e2e3d9;
  --odd-bk: #f3f4e5;
  --gradien-closed: repeating-linear-gradient(
    -45deg,
    rgba(245, 245, 245, 1),
    rgba(245, 245, 245, 1) 2px,
    rgba(242, 200, 191, 1) 2px,
    rgba(242, 200, 191, 1) 14.2px
  );
  --gradien-not-available: repeating-linear-gradient(
    -45deg,
    rgba(242, 200, 191, 1),
    rgba(242, 200, 191, 1) 2px,
    rgba(245, 245, 245, 1) 2px,
    rgba(245, 245, 245, 1) 14.2px
  );
}
.darkMode {
  color-scheme: dark;
  --background-color: #555;
  --background-full: black;
  --background-form: #424242;
  --text-color: whitesmoke;
  --even-bk: #333;
  --odd-bk: #444;
  --gradien-closed: repeating-linear-gradient(
    -45deg,
    rgba(50, 50, 50, 1),
    rgba(50, 50, 50, 1) 2px,
    rgba(0, 0, 0, 1) 2px,
    rgba(0, 0, 0, 1) 14.2px
  );
  --gradien-not-available: repeating-linear-gradient(
    -45deg,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 1) 2px,
    rgba(50, 50, 50, 1) 2px,
    rgba(50, 50, 50, 1) 14.2px
  );
}

.darkMode .icon-color {
  filter: invert(1);
}

.v-input__slot {
  border-radius: 10px !important;
}

.v-btn {
  border-radius: 10px !important;
}
.bold {
  font-weight: bold;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin-bottom: -20px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue